export const ImageLoader = (src, width, height) => {
    return `${src}&w=${width}&h=${height}`;
};
export const imagesSize = {
    sliderWidth: 1298,
    sliderHeight: 482,

    categoryIconWidth: 100,
    categoryIconHeight: 100,

    bannerWidth: 415,
    bannerHeight: 275,

    productMainImageWidth: 300,
    productMainImageHeight: 300,

    productDetailsImageWidth: 600,
    productDetailsImageHeight: 600,

    productDetailsImageIconWidth: 85,
    productDetailsImageIconHeight: 85,

    logoImageWidth: 105,
    // logoImageHeight: 105

}